import riot from 'riot';

riot.tag('form-mixin-hint', '<span class="ph-x-l-font">{ opts.text }</span>', function() {});
